import type { Translations } from './types';

export const zh: Translations = {
  appName: '北约字母教练',
  converter: '转换器',
  quiz: '字母测验',
  wordQuiz: '单词测验',
  settings: '设置',
  enterText: '输入要转换的文本',
  placeholder: '在此输入您的消息...',
  natoAlphabet: '北约字母',
  playPronunciation: '播放发音',
  stop: '停止',
  quickReference: '快速参考',
  showLess: '显示更少',
  viewFullAlphabet: '查看完整字母表 →',
  copied: '已复制！',
  copyFailed: '复制失败',
  speechNotAvailable: '语音合成不可用',
  voiceSettings: '语音设置',
  textToSpeechVoice: '文本转语音声音',
  testVoice: '测试声音',
  notifications: '通知',
  spacedRepetitionReminders: '间隔重复提醒',
  notificationDescription: '获取每日练习通知',
  language: '语言',
  interfaceLanguage: '界面语言',
  about: '关于北约字母教练',
  question: '问题',
  questionCount: '{current} / {total}',
  reviewYourAnswers: '检查您的答案',
  typeNatoWordForLetter: '请输入字母 {letter} 对应的北约单词',
  startVoiceInput: '开始语音输入',
  stopVoiceInput: '停止语音输入',
  aboutDescription: '通过互动测验和间隔重复学习北约语音字母。',
  version: '版本 1.0.0',
  builtWith: '使用现代网络技术构建',
  currentStreak: '当前连胜',
  totalSessions: '总会话数',
  accuracy: '准确率',
  learningProgress: '学习进度',
  startQuiz: '开始测验',
  restartQuiz: '重新开始测验',
  nextQuestion: '下一题',
  submitAnswer: '提交答案',
  showStats: '显示统计',
  hideStats: '隐藏统计',
  correctAnswer: '正确答案',
  yourAnswer: '您的答案',
  correct: '正确',
  incorrect: '错误',
  sessionComplete: '会话完成！',
  score: '得分',
  tryAgain: '重试',
  hint: '提示',
  femaleVoice: '女声',
  maleVoice: '男声',
  robotVoice: '机器人声音',
  dailyReminders: '您将根据学习进度收到练习北约字母的每日提醒。',
  speakAnswer: '说出您的答案',
  voiceInputActive: '正在听...',
  adaptiveLearning: '自适应学习',
  skipQuestion: '跳过',
  pressEnterToSubmit: '按Enter提交',
  pressEscapeToSkip: '按Escape跳过',
  exampleAnswers: '例如："Alpha"、"Bravo"、"Charlie"',
  notificationsPanelTitle: '通知',
  markAllAsRead: '全部标记为已读',
  noNotifications: '没有通知',
  natoHints: {
    A: '希腊字母表的第一个字母',
    B: '做得好，掌声！',
    C: '语音C，像名字一样',
    D: '河流三角形形成',
    E: '声音反射',
    F: '交际舞',
    G: '用球杆和洞的运动',
    H: '过夜的地方',
    I: '亚洲大国',
    J: '莎士比亚女主角',
    K: '重量单位（1000克）',
    L: '秘鲁首都',
    M: '麦克风的缩写',
    N: '秋天的月份',
    O: '学院奖',
    P: '父亲，非正式',
    Q: '加拿大省份',
    R: '莎士比亚角色',
    S: '山脉',
    T: '阿根廷舞蹈',
    U: '所有人相同的服装',
    V: '获胜者，冠军',
    W: '烈性酒精饮料',
    X: '医学成像',
    Y: '美国棒球运动员',
    Z: '非洲战士民族',
  },
  learning: '学习中',
  review: '复习',
  mastered: '已掌握',
  quizTimes: '测验时间',
  bestTime: '最佳时间',
  noTimesRecorded: '未记录时间',
  lastFiveTimes: '最近5次测验时间',
  spacedRepetitionDescription: '每组10道题会根据您的表现使用间隔重复进行调整。',
  theme: '主题',
  lightTheme: '浅色',
  darkTheme: '深色',
  rainbowTheme: '彩虹',
  systemTheme: '系统',
  appearance: '外观',
  chooseTheme: '选择您偏好的主题',
  speechRate: '语速',
  pitch: '音调',
  volume: '音量',
  // Custom Word Input
  enterCustomWord: '输入自定义单词',
  enterYourWordOrPhrase: '输入您的单词或短语...',
  useThisWord: '使用此单词',
  // WordDisplay localization
  currentWordLabel: '当前单词',
  customWordLabel: '自定义',
  currentWordSpeech: '当前单词是：{word}',
  difficultyLabels: {
    easy: '简单',
    medium: '中等',
    hard: '困难',
  },
  categoryLabels: {
    animals: '动物',
    places: '地点',
    nature: '自然',
    technology: '科技',
    home: '家庭',
    objects: '物品',
    transport: '交通',
  },
  // NATO Input specific translations
  natoInputTitle: '您的北约字母输入',
  natoInputPlaceholder: '输入北约字母："Alpha Bravo Charlie..."',
  natoInputListening: '正在听取...',
  natoInputLiveScore: '实时得分',

  // Quiz Header translations
  wordQuizInstructions:
    '将下面的单词转换为北约字母表。每个北约单词用空格或逗号分隔。',

  // Quiz Actions translations
  retry: '重试',
  checkAnswer: '检查答案',
  newRandomWord: '新随机单词',
  cancelCustom: '取消自定义',
  customWord: '自定义单词',

  // Quiz Results translations
  perfect: '完美！',
  results: '结果',
  expectedNato: '预期的北约：',
  play: '播放',
  letterByLetter: '逐个字母：',
};
